export default function Privacy() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Privacy Policy</h1>
          <p>
            At LEGITIMATELY, we value your privacy and are committed to
            protecting your personal data.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Q: What information do we collect?</h2>
              <p>
                A: We collect your name, email, and usage data to provide the
                best experience on LEGITIMATELY.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Q: How is your data used?</h2>
              <p>
                A: Your data helps us personalize services, improve our
                features, and comply with regulations.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Q: Your Rights?</h2>
              <p>
                A: You can manage your privacy preferences at any time through
                your LEGITIMATELY account settings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
